var exports = {
  "lO": "cta__xkenoh",
  "tT": "desktopActionGap__qkQEsb",
  "x$": "signInWrap___-hg2x",
  "PD": "desktopOnly__ir8NTM",
  "Hm": "hiddenBelowLg__f0ML96",
  "Jr": "MobileAuthAction__GzTYIn",
};

module.exports = exports;
